import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "distribution-widget-wrapper" }
const _hoisted_2 = { class: "distribution-chart-wrapper" }
const _hoisted_3 = { ref: "chart" }
const _hoisted_4 = { class: "usage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    widget: _ctx.widget,
    mode: _ctx.widgetMode,
    empty: !_ctx.stats || _ctx.total < 10,
    title: _ctx.$t('dashboard.distribution_widget.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("canvas", _hoisted_3, null, 512 /* NEED_PATCH */)
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.usage), 1 /* TEXT */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["widget", "mode", "empty", "title"]))
}